import { defineComponent as t, createBlock as r, openBlock as a, unref as l, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconSmartphoneScreenSize",
  __name: "IconSmartphoneScreenSize",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (d, e) => (a(), r(l(i), p(o, { "view-box": "0 0 24 24" }), {
      default: m(() => e[0] || (e[0] = [
        c("path", { d: "M15.69 5.295a.75.75 0 1 0-1.38-.59l-6 14a.75.75 0 0 0 1.38.59l6-14" }, null, -1),
        c("path", {
          "fill-rule": "evenodd",
          d: "M15.129 1.75H8.87a13.4 13.4 0 0 0-1.017.023C7.557 1.797 7.262 1.85 6.979 1.995A2.25 2.25 0 0 0 5.995 2.98C5.851 3.262 5.797 3.557 5.773 3.854 5.75 4.134 5.75 4.476 5.75 4.87v14.26c0 .395 0 .736.023 1.017a2.29 2.29 0 0 0 .222.875 2.25 2.25 0 0 0 .984.984 2.29 2.29 0 0 0 .875.222A13.46 13.46 0 0 0 8.87 22.25h6.258c.395 0 .736 0 1.017-.023a2.29 2.29 0 0 0 .875-.222 2.25 2.25 0 0 0 .984-.983 2.304 2.304 0 0 0 .222-.876c.023-.28.023-.622.023-1.017V4.87c0-.395 0-.736-.023-1.017a2.29 2.29 0 0 0-.222-.875 2.25 2.25 0 0 0-.983-.984 2.304 2.304 0 0 0-.876-.222c-.28-.023-.622-.023-1.017-.023m-7.47 1.582c.038-.02.113-.047.317-.064A12.754 12.754 0 0 1 8.9 3.25h6.2c.432 0 .712 0 .924.018.204.017.28.045.316.064a.75.75 0 0 1 .328.328c.02.037.047.112.064.316A12.796 12.796 0 0 1 16.75 4.9v14.2c0 .432 0 .712-.018.924-.017.204-.045.28-.064.316a.75.75 0 0 1-.328.328c-.037.02-.112.047-.316.064A12.796 12.796 0 0 1 15.1 20.75H8.9c-.432 0-.712 0-.924-.018-.204-.017-.28-.045-.316-.064a.75.75 0 0 1-.328-.328c-.02-.037-.047-.112-.064-.316A12.753 12.753 0 0 1 7.25 19.1V4.9c0-.432 0-.712.018-.924.017-.204.045-.28.064-.316A.75.75 0 0 1 7.66 3.332",
          "clip-rule": "evenodd"
        }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  f as default
};
